<template>
	<div class="success-code">
		<span v-if="isShow" class="icon iconfont iconlujing2 close" :class="{'bsStyle': s === 'BS' }"  @click="goPath('/home')"></span>
		<div class="success-code-wrap">
			<div class="logo">
				<span class="icon iconfont iconxingzhuangjiehe4"></span>
			</div>
			<p class="success-text">兑换成功</p>
			<p class="desc days">累计增加{{ timeLenStr }}VIP</p>
			<p class="desc">会员有效期{{originVip ? '延长': ''  }}至<span class="date">{{ vipEndTime.substr(0,10).replace('.','年').replace('.','月')+'日' }}</span></p>
			<button class="btn btn-blue-transparent" @click="goPath('/home')">返回首页</button>
		</div>
	</div>
</template>

<script>
import { isMini } from '@/utils';
	import { mapGetters } from 'vuex';

	export default {
		name: 'successCode',
		data() {
			return {
				originVip: null,
				s: localStorage.getItem('s')
			}
		},
		computed: {
      isShow(){
        return isMini() ? false : true
      },
			...mapGetters(['timeLenStr','vipEndTime'])
		},
		mounted() {
			this.originVip = this.$route.query && this.$route.query.originVip ? this.$route.query.originVip : null
		},
		methods: {
			goPath(url){
				this.$router.push({path:url})
			}
		},
	};
</script>

<style lang="less" scoped>
	.success-code {
		padding: 0 30px;
		.close {
			position: absolute;
			top: 16px;
			left: 16px;
		}
		.close.bsStyle{
			top: 46px;
		}
		.success-code-wrap{
			display: flex;
			flex-direction: column;
			align-items: center;
			.logo {
				height: 60px;
				line-height: 60px;
				margin-top: 110px;
			}
			/deep/ .iconfont {
				font-size: 60px;
				color: @baseGreen;
			}
			.success-text {
				margin-top: 20px;
				height:24px;
				font-size:24px;
				font-family:PingFangSC-Semibold,PingFang SC;
				font-weight:600;
				color:@darkBlack;
				line-height:24px;
			}
			.desc {
				margin-bottom: 10px;
				font-size: 12px;
				color: @subBlack;
				&.days{
					margin-top: 20px;
				}
			}
			.date {
				color: #FA5741;
			}
			.btn {
				margin-top: 110px;
			}
		}
	}
</style>
